var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"placeholder":_vm.placeholderValue,"auto-complete":"new-password","clearable":"","maxlength":"6"},on:{"input":e => (_vm.modelvalue = _vm.VerificationFormat(e, 1)),"change":_vm.InputCode},model:{value:(_vm.modelvalue),callback:function ($$v) {_vm.modelvalue=$$v},expression:"modelvalue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }